import { Button, useFileUrl, useUrlParamsValueToString } from "@bsm/component";
import { useNavigate } from "react-router-dom";

export default function InvoiceSignatoryDetails({
    id,
    name,
    fonction,
    signature,
}: InvoiceSignatoryDetailsProps) {
    const navigate = useNavigate();
    const urlParams = useUrlParamsValueToString();
    const getFileUrl = useFileUrl();

    return (
        <div className="space-y-2">
            <div className="flex justify-end">
            <Button
                className="btn-default mb-4"
                startIcon="fa-solid fa-pen"
                label="Edit"
                onClick={() => navigate(`edit?${urlParams}`)}
            />
            </div>
            <span>Signature</span>
            <img
                className="h-40"
                src={getFileUrl(signature.id)}
                alt={`${name}'s signature`}
            />
        </div>
    );
}

type InvoiceSignatoryDetailsProps = {
    id: number;
    name: string;
    fonction: string;
    signature: { id: number };
};
